import { Box, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../Themes/ColorScheme";
import { UserContext } from "../UserContext";

export const ClientOrderCard = ({ data, setSelectedOrder, closeDialog }) => {
	// console.log(data);
	const { selectedLocation } = useContext(UserContext);
	const { t } = useTranslation();

	/* const [content, setContent] = useState({}); */
	const [name, setName] = useState("");
	/* const [continuous, setContinuous] = useState(false); */

	useEffect(() => {
		if (data?.order_contents === undefined) return;

		data.order_contents.map((content) => {
			let array;
			if (content.content_type === 2) {
				array = content.name.split(", ");
				/* setContent(content); */
				if (array.length === 2) {
					setName(array[0]);
					/* setContinuous(false); */
				} else {
					setName(array[1]);
					/* setContinuous(true); */
				}
			} else {
				setName(t("orders.other_label"));
			}
		});
	}, []);

	return (
		selectedLocation !== undefined && (
			<>
				<Stack
					onClick={() => {
						setSelectedOrder(data);
						closeDialog(null);
					}}
					sx={{
						backgroundColor: ColorScheme.secondary,
						flexDirection: "row",
						display: "flex",
						color: ColorScheme.black,
						paddingX: 0,
						paddingY: "10px",
						borderRadius: "2px",
						marginBottom: "2px",
						alignItems: "center",
						border: "1px solid white",
						minWidth: "250px",
						":hover": {
							backgroundColor: ColorScheme.lightGrey,
						},
						cursor: "pointer"
					}}
				>
					{(
						<Box>
							<Box>
								<Typography
									sx={{
										fontSize: "14px",
										fontWeight: "700",
										color: ColorScheme.textSecondary
									}}
								>
									#{data.order_id}
								</Typography>
							</Box>
							<Typography
								sx={{
									fontSize: "10px",
									color: ColorScheme.black,
									fontWeight: "700"
									// minWidth: isMobile ? undefined : "80px"
								}}
							>
								{new Date(data.created_at).toLocaleString()}
							</Typography>
						</Box>
					)}
					<div style={{flex: 1}}></div>
					{!isMobile ? (
						<Box>
							<Typography
								sx={{
									fontSize: "10px",
									fontWeight: "700"
								}}
							>
								{data.total_vat_price.toFixed(2) +
									" " +
									t("common.currency_symbol")}
							</Typography>
						</Box>
					) : (
						<Box
							sx={{
								backgroundColor: data.order_succesful
									? ColorScheme.successPrimary
									: ColorScheme.dangerPrimary,
								padding: "4px",
								borderRadius: "20px",
								width: "70px",
								display: "flex",
								justifyContent: "center",
								alignItems: "center"
							}}
						>
							<Typography
								sx={{
									fontSize: "10px",
									fontWeight: "700",
									color: ColorScheme.secondary
								}}
							>
								{data.total_vat_price.toFixed(2) +
									" " +
									t("common.currency_symbol")}
							</Typography>
						</Box>
					)}

					{!isMobile && (
						<Box
							sx={{
								marginLeft: "20px",
								flexDirection: "row",
								display: "flex",
								justifyContent: "center",
							}}
						>
							{data.order_succesful &&
								data.refund_status !== 1 && (
									<Box
										sx={{
											width: "90px",
											// px: "10px",
											backgroundColor: ColorScheme.successPrimary,
											borderRadius: 10,
											alignItems: "center",
											justifyContent: "center",
											// paddingX: "25px",
											paddingY: "3px"
										}}
									>
										<Typography
											sx={{
												fontSize: "10px",
												color: ColorScheme.secondary,
												textAlign: "center"
											}}
										>
											{t("orders.paid_label")}
										</Typography>
									</Box>
								)}
							{data.refund_status === 1 && (
								<Box
									sx={{
										width: "90px",
										/* px: "10px", */
										backgroundColor: ColorScheme.darkGrey,
										borderRadius: 10,
										alignItems: "center",
										justifyContent: "center",
										/* paddingX: "20px", */
										paddingY: "3px"
									}}
								>
									<Typography
										sx={{
											fontSize: "10px",
											color: ColorScheme.secondary,
											textAlign: "center"
										}}
									>
										{t("orders.successful_cancel_label")}
									</Typography>
								</Box>
							)}
							{data.refund_status !== 1 &&
								!data.order_succesful && (
									<Box
										sx={{
											width: "90px",
											/* px: "10px", */
											backgroundColor: ColorScheme.dangerPrimary,
											borderRadius: 10,
											alignItems: "center",
											justifyContent: "center",
											/* paddingX: "15px", */
											paddingY: "3px"
										}}
									>
										<Typography
											sx={{
												fontSize: "10px",
												color: ColorScheme.textPrimary,
												textAlign: "center"
											}}
										>
											{t("orders.unpaid_label")}
										</Typography>
									</Box>
								)}
						</Box>
					)}
				</Stack>
			</>
		)
	);
};
